import Navbar from "../Components/Navbar.js";
import Main from "../Components/Main";
import Home from "../Components/Home";
import Programs from "../Components/Programs";
import ProgramsApple from "../Components/ProgramsApple.js";
import Counter from "../Components/Counter";
import Steps from "../Components/Steps";
import Pricing from "../Components/Pricing";
import Scroller from "../Components/scroller.js";
import Ques from "../Components/Ques.js";
import Footer from "../Components/Footer.js";
// import Policy from "../Components/Policy.js";
import Grid from "../Components/gridDemo";
import Timeline from "../Components/Timeline.js";
import { ShootingStars } from "../Components/ui/shooting-stars.jsx";
import { StarsBackground } from "../Components/ui/stars-background";
import ProgressBar from "../Components/ProgressBar"; // Adjust the path if necessary
import Analytics from "../Components/Analytics.jsx";
import Reviews from "../Components/Reviews.js";
import { FeaturesSectionDemo } from "../Components/FeatureGrid.js";
import { CarouselFinal } from "../Components/Carousel.js";
import LanguageTypewriter from "../Components/languageType.js";
import { Helmet } from "react-helmet-async";

import { black } from "tailwindcss/colors.js";
function HomePage() {
  return (
    <div className="">
      <Helmet>
        <title>ProdNx – The Best Web Time Tracker for Productivity</title>
        <meta
          name="description"
          content="Boost your focus and productivity with ProdNx – the ultimate Chrome extension to monitor your screen time, block distractions, and track habits in real-time."
        />
      </Helmet>
      <Analytics />
      <div
        style={{
          position: "fixed", // Position absolutely within the viewport
          top: 0,
          left: 0,
          width: "100vw", // Full width of the viewport
          maxWidth: "100vw", // Full width of the viewport
          height: "100vh", // Full height of the viewport
          overflow: "hidden", // Hide any extra overflow
          zIndex: "-1", // Send it to the background
          backgroundColor: "black",
        }}
      >
        <ShootingStars />
        <StarsBackground />
      </div>

      <Navbar />
      <Main />
      <LanguageTypewriter />

      <Home />
      {/* <Scroller /> */}
      {/* <ProgramsApple /> */}
      {/* <div className="flex flex-col items-center justify-center"> */}
      <CarouselFinal />
      <FeaturesSectionDemo />
      {/* </div> */}

      {/* <Programs /> */}
      <Timeline />
      {/* <Steps /> */}
      {/* <Pricing /> */}
      <Reviews />
      <Ques />
      <Footer page="Home" />
    </div>
  );
}

export default HomePage;
